export enum ResumeTypeEnum {
  CARD_ASYNC = "cardAsync",
}
